import Image from "next/image";
import EmphasizedText from "@/components/EmphasizedText";
import type { HeroProps } from "../types";
import { cn } from "@/lib/utils";

const defaultEmphasizeColor = "brand";

const HubHero = ({
  title,
  titleOverride,
  headingLabel,
  image,
  showSlantStripe,
  stringToEmphasize,
  emphasizeColor = defaultEmphasizeColor,
  titleClassName = "",
  children,
}: HeroProps) => {
  return (
    <div className="bg-primary">
      <div
        className={`flex justify-center ${image?.sourceUrl ? "lg:justify-between" : "lg:justify-start"}`}
      >
        {/* STRIPE */}
        {showSlantStripe ? (
          <div className="hidden relative lg:block">
            <svg
              className="-skew-x-12"
              aria-hidden="true"
              role="img"
              focusable="false"
              aria-label=""
              width="106"
              height="211"
              viewBox="0 0 106 211"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className={`stroke-${emphasizeColor}`}
                d="M77 -19L77 452.34"
                stroke-width="7"
                stroke-miterlimit="10"
              ></path>
            </svg>
          </div>
        ) : null}
        {/* TEXT */}
        <div className="px-4 pt-12 pb-4 md:py-4 max-w-screen-sm md:max-w-screen-md lg:max-w-full lg:px-0 lg:py-0 self-center lg:ml-12">
          {headingLabel ? (
            <p className="uppercase text-white mb-1 font-roboto">
              {headingLabel}
            </p>
          ) : null}
          <h1
            className={cn(
              "pt-0 text-4xl md:text-7xl leading-none text-white font-bold mb-0 mt-0 pr-4",
              titleClassName,
            )}
          >
            <EmphasizedText
              text={titleOverride || title}
              textEmphasis={stringToEmphasize}
              emphasisClass={`text-${emphasizeColor}`}
            />
          </h1>
        </div>
        {/* IMAGE */}
        {image?.sourceUrl && (
          <div
            className="hidden lg:block"
            style={{ height: `${image.height}px` }}
          >
            <Image
              height={image.height}
              width={image.width}
              src={image.sourceUrl}
              priority={true}
              alt={image.altText || ""}
              className="h-full max-w-none w-auto"
            />
          </div>
        )}
      </div>
      {children ? children : null}
    </div>
  );
};

export default HubHero;
